/**
 * _calc_markup.js — browser mirror of application/utils/calculators/markup.py.
 *
 * Every dollar comes from the cost the visitor typed. GST_RATE is the front
 * end's one owner of the rate (_gst.js). Change this, markup.py and
 * tests/fixtures/calculator_cases.json together.
 */

import { noAnswer, roundHalfUp } from "./_calc_math.js";
import { GST_RATE } from "./_gst.js";

const KEYS = ["price", "profit", "markup", "margin", "gst", "price_inc"];

function priceFor(v) {
    if (v.mode === "margin") {
        if (v.percent >= 100) return null;
        return v.cost / (1 - v.percent / 100);
    }
    return v.cost * (1 + v.percent / 100);
}

export function calculate(v) {
    const raw = priceFor(v);
    if (raw === null) {
        return noAnswer(KEYS, ["A margin can never reach 100%: that would mean the job cost "
                               + "nothing. Try a smaller margin."]);
    }
    const price = roundHalfUp(raw, 2);
    const profit = roundHalfUp(price - v.cost, 2);
    const gst = v.gst === "yes" ? roundHalfUp(price * GST_RATE, 2) : 0;
    const markup = v.cost > 0 ? roundHalfUp(profit / v.cost * 100, 1) : null;
    const margin = price > 0 ? roundHalfUp(profit / price * 100, 1) : null;
    const items = price > 0
        ? [{ description: v.item || "Materials and labour", quantity: 1, unit_price: price }]
        : [];
    return {
        outputs: { price, profit, markup, margin, gst, price_inc: roundHalfUp(price + gst, 2) },
        items,
        warnings: [],
    };
}
